export const PLACE_MARKER_IMAGE = require('./place-marker.png')
export const GO_BUTTON_IMAGE = require('./go-button.png')
export const USER_LOCATION_MARKER_IMAGE = require('./user-location-marker.png')
